import { ToastProgrammatic as Toast } from 'buefy';
import { Job } from 'bull';
import Vue from 'vue';
import { EVENTS } from '../store/modules/websocket/websocket.state';
import { useAction } from './store.util';
import { useWebsocket } from './websocket.util';

const displayToastError = () => {
  Toast.open({
    message: `Error processing. Please try again later.`,
    duration: 3000,
    type: 'is-danger'
  });
};

export const handleResolvePermissions = async function (this: Vue, job: Job) {
  const finishJobs: (jobState: boolean) => Promise<void> = useAction.call(
    this,
    'rolesAndPermissions/finishJobs'
  );

  if (!job) {
    displayToastError();
  }

  const {
    connectToWs,
    disconnectWs,
    joinRoom,
    listenOnceTo
  } = useWebsocket.call(this);

  const { id: jobId } = job;

  await connectToWs();
  joinRoom(jobId);

  try {
    await listenOnceTo(EVENTS.PERMISSION_RESOLVED);
    await finishJobs(true);
    await disconnectWs();
  } catch (error) {
    await finishJobs(false);
    displayToastError();
    await disconnectWs();
    return;
  }
};
